import { render, staticRenderFns } from "./bottom-select.vue?vue&type=template&id=f5f7dcbe&scoped=true&"
import script from "./bottom-select.vue?vue&type=script&lang=js&"
export * from "./bottom-select.vue?vue&type=script&lang=js&"
import style0 from "./bottom-select.vue?vue&type=style&index=0&id=f5f7dcbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f7dcbe",
  null
  
)

export default component.exports